import * as serverApi from '@/api/server'

// eslint-disable-next-line import/prefer-default-export
export const getProjects = () => serverApi.get('/v3/bcr/projects')
